import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { IMAGE_PATHS } from 'constants/imagePaths';
import parse from 'html-react-parser';
import { sanitizeHtml } from 'components/sanitizeHtml';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';
import HowItWorksContent from './HowItWorksContent';
import HowItWorksStep from './HowItWorksStep';

const HowItWorks: React.FC = () => {
	const { translate } = useTranslate();

	const steps = [
		{ number: 1, description: translate('Common.createBusinessAccount') },
		{ number: 2, description: translate('Common.createEmployerBranding') },
		{ number: 3, description: translate('Common.postJob') },
		{ number: 4, description: translate('Common.createMemberAccount') },
		{ number: 5, description: translate('Common.uploadResume') },
		{ number: 6, description: translate('Common.applyImmediately') },
	];

	return (
		<section className="how-it-works py-80">
			<Container>
				<Row className="how-it-works-row">
					<Col lg={5}>
						<div className="how-it-works-steps">
							{steps.map((step) => (
								<HowItWorksStep
									key={step.number}
									number={step.number}
									description={step.description}
								/>
							))}
						</div>
					</Col>
					<Col lg={7}>
						<HowItWorksContent
							heading={parse(sanitizeHtml(translate('Home.howItWorkTitle')))}
							descriptions={[
								translate('Home.howItWorkDescription1'),
								parse(sanitizeHtml(translate('Home.howItWorkDescription2'))),
							]}
							imageSrc={IMAGE_PATHS.HowItWorksImg}
							imageAlt="how-it-works"
						/>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default HowItWorks;
